import { emptyValidator, formValidator } from "../../validators";

// Custom validator for checking if at least one customer is selected
const customerListValidator = () => ({
    func: (value) => {
        if (!Array.isArray(value) || value.length === 0) {
            return "At least one customer must be added";
        }
        return null;
    },
    message: () => "At least one customer must be added",
});


const userCustomerGroupValidationStatus = {
    groupName: {
        validators: [emptyValidator()],
        name: "Group Name",
    },
    customers: {
        validators: [customerListValidator()],
        name: "Customers",
    },
};

export const userCustomerGroupValidation = (data) => {
    return formValidator(data, userCustomerGroupValidationStatus);
};
